/**
* Function for escape special chars from string in regexp
* @param {string} string - string
* @return {string} string with escaped characters for regexp
*/
function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}
export default escapeRegExp;